import React from 'react';
import App_data from '../../views/config/App_data';

const onclick = e => {
  e.preventDefault();
  document.body.classList.toggle('sidebar-mobile-show');
};

function MobileSidebarToggle() {
  return (
    <button
      type='button'
      className='menu_toggle hidden-md-up btn-reset'
      aria-label='Open navigation menu'
      onClick={onclick}
    >
      <img
        src={`${App_data.frontend_url}/img/sidebar/menu.png`}
        alt='burger icon'
      />
    </button>
  );
}

export default MobileSidebarToggle;



// WEBPACK FOOTER //
// ./src/components/Header/MobileSidebarToggle.jsx